<template>
    <div>
        <div class="panel panel-default">
            <div class="panel-heading">
                Télécharger les documents
            </div>

            <div class="panel-body">
                <div class="col-lg-3 form-group">
                    <button
                        v-if="!loading"
                        @click="download"
                        class="btn btn-primary"
                        :disabled="!signatureDone"
                    >
                        Télécharger les documents
                    </button>
                    <div v-else>
                        <loader :inline="true"></loader>
                        Envoi en cours
                    </div>
                </div>

                <div class="col-lg-3" v-if="signatureDone && operation.state !== 'DONE'">
                    <button
                        v-if="!confirmingOperation"
                        @click="openConfirmOperation"
                        class="btn btn-primary"
                    >
                        Envoyé à la compagnie
                    </button>
                    <div v-else>
                        <loader :inline="true"></loader>
                        Envoi en cours
                    </div>
                </div>
            </div>
        </div>

        <modal :show.sync="showConfirmOperation">
            <div class="modal-header" slot="modal-header">
                <h4>Voulez-vous vraiment valider cette opération ?</h4>
            </div>

            <div class="modal-body" slot="modal-body">
                En validant cette opération, vous confirmez avoir envoyé les
                documents à la compagnie"
            </div>

            <div class="modal-footer" slot="modal-footer">
                <loader v-if="confirmingOperation" :inline="true"></loader>
                <div v-else>
                    <button
                        @click.prevent="cancelConfirmOperation()"
                        class="btn btn-default"
                    >
                        Non
                    </button>
                    <button
                        @click.prevent="doConfirmOperation()"
                        class="btn btn-primary"
                    >
                        Oui
                    </button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import {ObjectDebounce} from 'wasync';
import {
    setSaxoMigrationAsDone,
    operationDocumentsToZip
} from '../../api/operations';
import {manager as msgManager} from '../../messages';
import Modal from 'vue-strap/src/Modal';
import Loader from '../Loader';

export default {
    props: {
        /**
         * Contract operation.
         */
        operation: {
            required: true
        },

        /**
         * Documents can only be downloaded if signature is finished.
         */
        signatureDone: {
            type: Boolean,
            default: false
        }
    },

    components: {Modal, Loader},

    data() {
        return {
            /**
             * Display or not the loading icon.
             */
            loading: false,

            /**
             * Indicates if the modal to confirm the operation is displayed
             */
            showConfirmOperation: false,

            confirmingOperation: false
        };
    },

    methods: {
        /**
         * Downloads a ZIP file with the whole list of documents.
         */
        async download() {
            this.loading = true;
            const res = await operationDocumentsToZip(
                {operation: this.operation.id}
            );
            this.loading = false;
            window.location.href = res.body.file;
        },

        openConfirmOperation() {
            this.showConfirmOperation = true;
        },

        /**
         * Hides the operation-confirming modal.
         */
        cancelConfirmOperation() {
            this.showConfirmOperation = false;
        },

        /**
         * The operation is sent to the API in order to update its status to
         * 'DONE'. Since Saxo operations are not sent to Generali Automation,
         * the status is always updated.
         *
         * An event is emitted to the parent to update the status when received
         * from the API.
         */
        doConfirmOperation: new ObjectDebounce({wait: 0}).func({
            validate() {
                return true;
            },

            prepare() {
                this.confirmingOperation = true;
            },

            cleanup() {
                // this.confirmingOperation = false;
                this.showConfirmOperation = false;
            },

            async run() {
                await setSaxoMigrationAsDone({ operation: this.operation.id });
                this.$emit('saxo');
            },

            success() {
                msgManager.push(
                    'Succès',
                    'Operation validé',
                    'success'
                );
            },

            failure(err) {
                msgManager.push('Erreur', err, 'danger');
            }
        })
    }
};
</script>



// WEBPACK FOOTER //
// OperationSaxo.vue?a8b95464